import React from 'react';
import { useSelector } from 'react-redux';
import DivisionSelectorItem from './DivisionSelectorItem';
import StyledDivisionSelectorOptionWrapper from '../../../../../../style/Common/Header/StyledSessionInfo/StyledDivisionSelector/StyledDivisionSelectorOption/StyledDivisionSelectorOptionWrapper';

/**
 * @description
 * Division selector option component.
 * @returns {React.ReactElement}
 */
const DivisionSelectorOption = ({ setIsOpen, ...props }) => {
  const currDiv = useSelector(state => state?.common?.currDiv);
  const divisionList = useSelector(state => state?.common?.allDiv);

  return (
    <StyledDivisionSelectorOptionWrapper>
      {divisionList?.map(div => (
        <DivisionSelectorItem
          key={div}
          isSelected={currDiv === div}
          setIsOpen={setIsOpen}
        >
          {div}
        </DivisionSelectorItem>
      ))}
    </StyledDivisionSelectorOptionWrapper>
  );
};

export default DivisionSelectorOption;
